export interface BlogPost {
  id: string
  slug: string
  title: string
  excerpt: string
  publishedAt: string
  author: {
    name: string
    image?: string
  }
  mainImage?: string
  substackUrl: string // Direct link to Substack article
}

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug: 'welcome-to-our-first-post',
    title: 'Welcome to our first post!',
    excerpt:
      "IBD rant's favorite raves of the week including videos, rants, and research",
    publishedAt: '2025-12-11',
    author: {
      name: 'IBD Rant',
    },
    mainImage:
      'https://cdn.magicpatterns.com/uploads/rmQMKPswopSdg574rrKDkp/Screenshot_2025-12-11_at_10.08.28_AM.png',
    substackUrl:
      'https://open.substack.com/pub/ibdrant/p/ibd-rant-rave?utm_campaign=post-expanded-share&utm_medium=web',
  },
]

// Helper functions
export const getAllPosts = (): BlogPost[] => {
  return blogPosts.sort(
    (a, b) =>
      new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  )
}

export const getPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find((post) => post.slug === slug)
}

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
